import React, { Fragment, Component } from "react";
import {Route, Switch, Redirect, BrowserRouter as Router, useLocation} from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './Assets/css/Navigation.css';
import './Assets/css/main.css';
import './Assets/css/IT.css';
import './Assets/css/experience.css';
import './Assets/css/Contact.css';
import './Assets/css/bootstrap.min.css';
import './Assets/css/AutomationCSS.scss';
import './Assets/css/aos.css';
import './Assets/css/aboutStyleCSS.css';
import './Assets/css/App.css';


// Components
import MainHeader from "./components/Main Page/MainHeader";
import AboutMe from "./components/Main Page/AboutMe";
import ContactForm from "./components/Main Page/contact";
import ScrollTop from "./components/ScrollTop";

// Footer
import Footer from "./components/Footer/Footer";
import DeveloperHeader from "./components/Footer/BecomeDeveloperHeader";
import Developer from "./components/Footer/BecomeADeveloper";
import PayHeader from "./components/Footer/HowToPayHeader";
import Pay from "./components/Footer/HowToPay";
import TermsHeader from "./components/Footer/TermsHeader";
import Terms from "./components/Footer/Terms";

// Business Card
import BusinessCard from "./components/BusinessCard/BusinessCard";

// Pages
import SubmitPage from "./pages/submit"
import ComingSoonPage from "./pages/comingsoon";
import NotFoundPage from "./pages/404";

// IT
import ITHeader from "./components/IT Page/ITHeader";
import ITServicesGrid from "./components/IT Page/ITServicesGrid";
import ITTabs from "./components/IT Page/ITTabs";
import PageNavigation from "./components/Navigation/PageNavigation";

// WA
import WAHeader from "./components/Web&App/WAHeader";
import WebAppServicesGrid from "./components/Web&App/WebAppServicesGrid";

// Automation
import AutomationHeader from "./components/Automation/AutomationHeader";
import AutomationServicesGrid from "./components/Automation/AutomationServicesGrid";

const Main = () =>  (
  <Fragment>
    <MainHeader />
    <AboutMe />
    <ContactForm />
  </Fragment>
);

const IT = () => (
  <Fragment>
    <ITHeader/>
    <ITServicesGrid/>
    <ITTabs/>
  </Fragment>
  );

const WebAndApp = () => (
  <Fragment>
    <WAHeader/>
    <WebAppServicesGrid/>
  </Fragment>
);

const AutomationPage = () => (
  <Fragment>
    <AutomationHeader />
    <AutomationServicesGrid />
  </Fragment>
);

const HowToPay = () =>  (
  <Fragment>
    <PayHeader />
    <Pay />
  </Fragment>
);

const BecomeADeveloper = () =>  (
  <Fragment>
    <DeveloperHeader />
    <Developer />
  </Fragment>
);

const TermsAndConditions = () =>  (
  <Fragment>
    <TermsHeader />
    <Terms />
  </Fragment>
);

const Submit = () =>  (
  <Fragment>
    <SubmitPage />
  </Fragment>
);

const ComingSoon = () =>  (
  <Fragment>
    <ComingSoonPage />
  </Fragment>
);

const NotFound = () =>  (
  <Fragment>
    <NotFoundPage />
  </Fragment>
);

const Layout = ({ children }) => {
  const location = useLocation();
  const isCardPage = location.pathname.startsWith("/card/");

  return (
    <Fragment>
      {!isCardPage && <ScrollTop />}
      {!isCardPage && <PageNavigation />}
      {children}
      {!isCardPage && <Footer />}
    </Fragment>
  );
};

class App extends Component {
  render() {
    return (
      <Router>
        <Layout>
          <Switch>
            <Route exact path="/card/:slug" component={BusinessCard} />
            <Route exact path="/" component={Main} />
            <Route exact path="/submit" component={Submit} />
            <Route exact path="/comingsoon" component={ComingSoon} />
            <Route exact path="/404" component={NotFound} />

            {/* Primary routes: kebab-case lowercase (SEO-standard URLs) */}
            <Route exact path="/it" component={IT} />
            <Route exact path="/web-app" component={WebAndApp} />
            <Route exact path="/how-to-pay" component={HowToPay} />
            <Route exact path="/automation" component={AutomationPage} />
            <Route exact path="/terms-and-conditions" component={TermsAndConditions} />
            <Route exact path="/become-a-developer" component={BecomeADeveloper} />
            <Route exact path="/referrals-affiliates" component={ComingSoon} />

            {/* Legacy capitalised URLs → redirect to the new kebab-case paths
                so previously shared links and Instagram bio links keep working */}
            <Redirect exact from="/IT" to="/it" />
            <Redirect exact from="/Web-App" to="/web-app" />
            <Redirect exact from="/How-To-Pay" to="/how-to-pay" />
            <Redirect exact from="/Automation" to="/automation" />
            <Redirect exact from="/Terms-And-Conditions" to="/terms-and-conditions" />
            <Redirect exact from="/Become-a-Developer" to="/become-a-developer" />
            <Redirect exact from="/Referrals-Affiliates" to="/referrals-affiliates" />

            <Redirect to="/404"/>
          </Switch>
        </Layout>
      </Router>
    );
  }
}

export default App;
